


  
  

  var faGrid2 = {
    prefix: 'fass',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M224 32L32 32l0 192 192 0 0-192zm0 256L32 288l0 192 192 0 0-192zM288 32l0 192 192 0 0-192L288 32zM480 288l-192 0 0 192 192 0 0-192z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fass',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendar = {
    prefix: 'fass',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fass',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM167 239L271 135l17-17L321.9 152l-17 17-87 87 87 87 17 17L288 393.9l-17-17L167 273l-17-17 17-17z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faSplotch = {
    prefix: 'fass',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M256 0h80l30.9 103c10.8 35.9 37.7 64.7 72.8 77.9L512 208v64l-73.2 54.9c-34 25.5-52 67-47.3 109.3L400 512H304l-73.3-58.6c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L16 464V376l24.3-29.1c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L0 160V80L101.1 97.2c44 7.5 88.5-10.1 115.5-45.5L256 0z'
      
    ]
  };

  

  
  

  var faChevronRight = {
    prefix: 'fass',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fass',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fass',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-45.4-35.2C614.4 398.3 640 354.1 640 304c0-79.5-64.5-144-144-144l-16 0 0 64 16 0c44.2 0 80 35.8 80 80c0 36-23.8 66.5-56.6 76.5l-104.3-81C435.7 274.7 448 242.8 448 208c0-79.5-64.5-144-144-144L144 64c-9.8 0-19.3 1-28.6 2.8l-67-52zM194.2 128L304 128c44.2 0 80 35.8 80 80c0 20-7.3 38.2-19.4 52.3L194.2 128zM446.8 448l-81.2-64L336 384c-44.2 0-80-35.8-80-80c0-2.1 .1-4.1 .2-6.1l-55.4-43.6c-5.7 15.5-8.8 32.3-8.8 49.8c0 79.5 64.5 144 144 144l110.8 0zM30.2 119.8C11.3 144.2 0 174.8 0 208c0 79.5 64.5 144 144 144l16 0 0-64-16 0c-44.2 0-80-35.8-80-80c0-18.3 6.1-35.1 16.5-48.6L30.2 119.8z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faPlus = {
    prefix: 'fass',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faCopy = {
    prefix: 'fass',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M352 0l96 96 0 288-288 0L160 0 352 0zM64 128l64 0 0 64-64 0 0 256 192 0 0-32 64 0 0 32 0 64-64 0L64 512 0 512l0-64L0 192l0-64 64 0z'
      
    ]
  };

  

  
  

  var faChevronDown = {
    prefix: 'fass',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z'
      
    ]
  };

  

  
  

  var faMagnifyingGlass = {
    prefix: 'fass',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faXmarkLarge = {
    prefix: 'fass',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M70.6 57.4L48 34.7 2.7 80l22.6 22.6L178.7 256 25.4 409.4 2.7 432 48 477.3l22.6-22.6L224 301.3 377.4 454.6 400 477.3 445.3 432l-22.6-22.6L269.3 256 422.6 102.6 445.3 80 400 34.7 377.4 57.4 224 210.7 70.6 57.4z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fass',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M0 208C0 98.5 84.6 8.8 192 .6L192 96c107.4 8.2 192 97.9 192 207.4s-84.6 199.2-192 207.4l0-95.4C84.6 407.2 0 317.5 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fass',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M16 48l96 0 0 96-96 0 0-96zm0 160l96 0 0 96-96 0 0-96zm96 160l0 96-96 0 0-96 96 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faCircleInfo = {
    prefix: 'fass',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0-24 0 0-48 24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm72-144l-64 0 0-64 64 0 0 64z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faCircleSmall = {
    prefix: 'fass',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faTrash = {
    prefix: 'fass',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM416 128L32 128 56 512l336 0 24-384z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'fass',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M288 32C129.6 32 30 181.3 0 256c30 74.7 129.6 224 288 224s258-149.3 288-224C546 181.3 446.4 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm48 0c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8L288 256l-94.2-18.8c-1.2 6.1-1.8 12.4-1.8 18.8z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fass',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 184c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4l0 23.6-48 0 0-24 0-13.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L224 176c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 184l0-48 48 0 0 48-48 0z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faCircle = {
    prefix: 'fass',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fass',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M331 75L256 0 181 75 75 75l0 106L0 256l75 75 0 106 106 0 75 75 75-75 106 0 0-106 75-75-75-75 0-106L331 75z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fass',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M320 0L288 0l0 64 32 0 82.7 0L201.4 265.4 178.7 288 224 333.3l22.6-22.6L448 109.3l0 82.7 0 32 64 0 0-32 0-160 0-32L480 0 320 0zM32 32L0 32 0 64 0 480l0 32 32 0 424 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448 64 96l96 0 32 0 0-64-32 0L32 32z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faSort = {
    prefix: 'fass',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M160 32L0 192l0 32 320 0 0-32L160 32zm0 448L320 320l0-32L0 288l0 32L160 480z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fass',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm409 17L297 385l-17 17L246.1 368l17-17 71-71L120 280l-24 0 0-48 24 0 214.1 0-71-71-17-17L280 110.1l17 17L409 239l17 17-17 17z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faCircleChevronUp = {
    prefix: 'fass',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-345L377 271l17 17L360 321.9l-17-17-87-87-87 87-17 17L118.1 288l17-17L239 167l17-17 17 17z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faCircleCheck = {
    prefix: 'fass',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faStar = {
    prefix: 'fass',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M288.1 0l86.5 164 182.7 31.6L428 328.5 454.4 512 288.1 430.2 121.7 512l26.4-183.5L18.9 195.6 201.5 164 288.1 0z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fass',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96l64 0 32 0 0 64-32 0-64 0c-53 0-96 43-96 96s43 96 96 96l64 0 32 0 0 64-32 0-64 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-64 0-32 0 0-64 32 0 64 0c53 0 96-43 96-96s-43-96-96-96l-64 0-32 0 0-64 32 0 64 0c88.4 0 160 71.6 160 160zM192 224l192 0 32 0 0 64-32 0-192 0-32 0 0-64 32 0z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fass',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fass',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM222.5 150c25.6-23.6 59.9-38 97.5-38c79.5 0 144 64.5 144 144c0 24.7-6.2 47.9-17.1 68.2l-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8l11.6 58.2L222.5 150zM444.9 446.6L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L85.7 163.5C60.2 197.1 42.1 230.8 32 256c30 74.7 129.6 224 288 224c46.9 0 88.6-13.1 124.9-33.4zM324.8 351.9l-99.1-78.1C234 318.3 273.1 352 320 352c1.6 0 3.2 0 4.8-.1z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fass',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM239 345L135 241l-17-17L152 190.1l17 17 87 87 87-87 17-17L393.9 224l-17 17L273 345l-17 17-17-17z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faCircleExclamation = {
    prefix: 'fass',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-384l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 368l0-48 48 0 0 48-48 0z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBars = {
    prefix: 'fass',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64l448 0 0 64L0 128 0 64zM0 224l448 0 0 64L0 288l0-64zM448 384l0 64L0 448l0-64 448 0z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faBadge = {
    prefix: 'fass',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fass',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M512 32l0 96L0 128 0 32l512 0zM32 160l448 0 0 320L32 480l0-320zm128 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faWebhook = {
    prefix: 'fass',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M208 128c0-44.2 35.8-80 80-80s80 35.8 80 80c0 10.7-2.1 20.8-5.8 30l44.5 18c6-14.9 9.3-31.1 9.3-48.1C416 57.3 358.7 0 288 0S160 57.3 160 128c0 37.1 15.8 70.5 41 93.9L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5 12.7-20.3-20.3-12.7C223 181.7 208 156.6 208 128zm81.7 48l82.8 132.5 12.7 20.4 20.4-12.8c12.3-7.7 26.8-12.1 42.4-12.1c44.2 0 80 35.8 80 80s-35.8 80-80 80c-22.2 0-42.2-9-56.8-23.6l-34.1 33.8C380.3 497.5 412.5 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-16.3 0-31.9 3.1-46.3 8.6L330.4 150.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0zM448 432c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24L232 360l-24 0 0 24c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-39.7 28.9-72.7 66.8-78.9L107 257.7C46.3 267.7 0 320.4 0 384c0 70.7 57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l152.7 0c8.3 14.3 23.8 24 41.6 24z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fass',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M10.2 461L0 512l51-10.2L160 480 420.7 219.3l-16-16-96-96-16-16L32 352 10.2 461zM315.3 68.7l16 16 96 96 16 16 34.7-34.7L512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 315.3 68.7zM99.9 352l12.1 0 0 48 48 0 0 12.1-23.7 23.7-75.1 15 15-75.1L99.9 352zM326.6 176l-11.3 11.3-144 144L160 342.6 137.4 320l11.3-11.3 144-144L304 153.4 326.6 176z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faCircleChevronRight = {
    prefix: 'fass',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm345 17L241 377l-17 17L190.1 360l17-17 87-87-87-87-17-17L224 118.1l17 17L345 239l17 17-17 17z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  



export {

  faGrid2,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendar,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faSplotch,
  

  faChevronRight,
  

  faChevronLeft,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faPlus,
  
  faAdd,
  

  faCopy,
  

  faChevronDown,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faXmarkLarge,
  

  faHurricane,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faCircleSmall,
  

  faTrash,
  

  faEye,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faCircle,
  

  faSeal,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faSort,
  
  faUnsorted,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faStar,
  

  faLinkSimple,
  

  faChevronUp,
  

  faEyeSlash,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBars,
  
  faNavicon,
  

  faBadge,
  

  faBoxArchive,
  
  faArchive,
  

  faWebhook,
  

  faPencil,
  
  faPencilAlt,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

};
